import React from 'react';

export const GlobeIcon: React.FC = () => (
  <svg
    className="globe-icon"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.6"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    <circle cx="12" cy="12" r="9" />
    <path d="M3 12h18" />
    <path d="M12 3c2.5 2.5 3.75 5.5 3.75 9S14.5 18.5 12 21c-2.5-2.5-3.75-5.5-3.75-9S9.5 5.5 12 3z" />
    <path d="M5.2 6.4a13 13 0 0 0 13.6 0" />
    <path d="M5.2 17.6a13 13 0 0 1 13.6 0" />
  </svg>
);
